module.exports = __webpack_public_path__ + "static/media/GO.a66cf21b.jpg";